import { Component, OnInit } from '@angular/core';
import { Experience, WMAIApiService, SchedaIntense, Attachment, Item, Stop, Word, Ost, Immagine } from '../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, ExpLocalStorage, AppInformationService } from '../../core/services';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ImageModal, ConfirmModal, SimpleModal } from 'src/app/core/templates';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';

@Component({
  selector: 'app-saved-ost',
  templateUrl: './saved-ost.component.html',
})
export class SavedOstComponent implements OnInit {
  isMapVisible: boolean = false;
  isUserLoggedIn = false;
  ost: Ost;
  id: number;
  ostid: number;
  loading: boolean = true;
  imageUrl: string = "";
  firstStep: boolean = false;
  secondStep: boolean = false;
  thirdStep: boolean = false;

  isSmallScreen: boolean = false;
  isMobile: boolean = false;
  immagine: Immagine;
  immagini: Attachment[];
  currentIndex: number = 0;
  maxIndex: number = 0;

  tipologie: Attachment[];

  allegati: Attachment[] = [];
  allegato: Attachment;

  itemCurrentIndex: number = 0;
  itemMaxIndex: number = 0;
  paramsSubscription: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private wmaiservice: WMAIApiService,
    private auth: AuthService,
    private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver,
    private activatedroute: ActivatedRoute,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private modalService: SuiModalService,
    private ostLocalStorage: ExpLocalStorage,
    private appService: AppInformationService
  ) {
    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });
    this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
    this.isMobile = this.appService.iAmMobile();

  }

  ngOnInit() {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    this.isMapVisible = this.wgisservice.getMapVisible();
    window.scrollTo(0, 0);
    // console.log("ost offline");
    this.paramsSubscription = this.activatedRoute.params.subscribe((param: any) => {
      this.id = param['id'];
      // console.log(this.id);
      if (this.id != null) {
        var result: Ost[] = this.ostLocalStorage.findLocalOst(this.id);
        // console.log(result);
        if(result.length > 0){
          this.ost = result[0];
          this.loading = false;
          // this.wgisservice.showOstByObj(this.ost);
          this.firstStep = true;
        }
      }
    });

    this.firstStep = true;
  }

  ngOnDestroy() {
    // this.wgisservice.clearSelection();
    this.paramsSubscription.unsubscribe();
  }
  /**
   * mappa a display
   */
  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }
  /**
   * prossima immagine
   */
  nextImage() {
    if (this.currentIndex >= this.maxIndex) this.currentIndex = 0;
    else this.currentIndex++;
    this.immagine = this.ost.immagine[this.currentIndex];
  }
  /**
   * immagine precedente
   */
  previousImage() {
    if (this.currentIndex <= 0) this.currentIndex = this.maxIndex;
    else this.currentIndex--;
    this.immagine = this.ost.immagine[this.currentIndex];
  }

}
